/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest, MenuItem } from "shared/bootstrap";
import moment from "moment";
import publicLocale from "./i18n/public.json";
import adminLocale from "./i18n/admin.json";
import "moment/locale/nl";
import { VuePlugins } from "shared/bootstrap/types";
import Vue, { ComponentOptions, AsyncComponent } from "vue";

moment.locale("nl");

export type TComponent = ComponentOptions<Vue> | typeof Vue | AsyncComponent;
export interface Config {
  settingComponents?: TComponent[];
}

function loadConfig(c: Partial<Config> = {}): Config {
  return {
    ...c,
  };
}

export default function (c?: Partial<Config>): ModuleManifest {
  const config = loadConfig(c);

  const menuItems: MenuItem[] = [
    {
      to: { name: "login-request" },
      title: "base.menuItems.login",
      icon: "sign-in-alt",
      hideAuth: true,
    },
  ];

  if (config.settingComponents)
    menuItems.push({
      to: { name: "settings" },
      title: "base.menuItems.settings",
      icon: "cog",
      hideNoAuth: true,
      bottom: true,
    });

  menuItems.push({
    to: { name: "logout" },
    title: "base.menuItems.logout",
    icon: "sign-out-alt",
    hideNoAuth: true,
    bottom: true,
  });

  return {
    menuItems,
    routes: [
      {
        path: "/login",
        component: () => import("./layouts/Auth.vue"),
        children: [
          {
            path: "/",
            name: "login-request",
            meta: {
              title: "base.menuItems.login",
              auth: false,
            },
            component: () => import("./pages/LoginRequest.vue"),
          },
          {
            path: ":token/:suffix?",
            name: "login-process-token",
            props: true,
            meta: {
              title: "base.menuItems.login",
            },
            component: () => import("./pages/LoginProcessToken.vue"),
          },
        ],
      },
      {
        path: "/logout",
        component: () => import("./layouts/Auth.vue"),
        children: [
          {
            path: "/",
            name: "logout",
            meta: {
              title: "base.menuItems.logout",
            },
            component: () => import("./pages/Logout.vue"),
          },
        ],
      },
      {
        path: "/settings",
        name: "settings",
        meta: {
          auth: true,
          title: "base.menuItems.settings",
          settingComponents: config.settingComponents,
        },
        component: () => import("./pages/Settings.vue"),
      },
    ],
    localisation: { key: "base", messages: publicLocale },
  };
}

export const AdminManifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "login-stats" },
      title: "base.menuItems.loginStats",
      icon: "users",
    },
  ],
  routes: [
    {
      path: "/login-statistieken",
      name: "login-stats",
      component: () => import("./pages/LoginStats.vue"),
      meta: {
        title: "base.menuItems.loginStats",
      },
    },
  ],
  vuePlugins: [VuePlugins.CompendaIntegration],
  localisation: { key: "base", messages: adminLocale },
};
